import { ModuleModel } from '../../module.model.interface';

export enum CustomPropObjectType {
  DataEntry,
  Organization,
  Assignment,
  Profile,
  ModificationRequest,
  ClarificationRequest,
  Batch,
  Case,
  Role,
  Form,
  Bulletin,
  CodeList,
  CodeListItem,
  Label,
  LabelRelation,
  OfficialAct,
  SecGroup,
  SecGroupRelation,
  WorkflowTemplate,
}

export class CustomPropObjectTypeDetail implements ModuleModel {
  public discriminator = 'CustomPropObjectTypeDetail';
  public id: string;
  public name: string;
  public typename: string;

  constructor(options?: {
    id: string,
    name: string,
    typename: string
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
      this.typename = options.typename;
    }
  }
}

export const CustomPropObjectTypeMap = {
  DataEntry: new CustomPropObjectTypeDetail({ id: 'DataEntry', name: 'Adatszolgáltatás', typename: 'DataEntry' }),
  Organization: new CustomPropObjectTypeDetail({ id: 'Organization', name: 'Szervezet', typename: 'Organization' }),
  Assignment: new CustomPropObjectTypeDetail({ id: 'Assignment', name: 'Jogosultság', typename: 'Assignment' }),
  Profile: new CustomPropObjectTypeDetail({ id: 'Profile', name: 'Felhasználó', typename: 'Profile' }),
  ModificationRequest: new CustomPropObjectTypeDetail({ id: 'ModificationRequest', name: 'Módosítási kérelem', typename: 'ModificationRequest' }),
  ClarificationRequest: new CustomPropObjectTypeDetail({ id: 'ClarificationRequest', name: 'Adategyeztetés', typename: 'ClarificationRequest' }),
  Batch: new CustomPropObjectTypeDetail({ id: 'Batch', name: 'Tömeges művelet', typename: 'Batch' }),
  Case: new CustomPropObjectTypeDetail({ id: 'Case', name: 'Ügyfélkapcsolat', typename: 'Case' }),
  Role: new CustomPropObjectTypeDetail({ id: 'Role', name: 'Szerepkör', typename: 'Role' }),
  Form: new CustomPropObjectTypeDetail({ id: 'Form', name: 'Űrlap', typename: 'Form' }),
  Bulletin: new CustomPropObjectTypeDetail({ id: 'Bulletin', name: 'Közlemény', typename: 'Bulletin' }),
  CodeList: new CustomPropObjectTypeDetail({ id: 'CodeList', name: 'Kódlista', typename: 'CodeList' }),
  CodeListItem: new CustomPropObjectTypeDetail({ id: 'CodeListItem', name: 'Kódlista elem', typename: 'CodeListItem' }),
  Label: new CustomPropObjectTypeDetail({ id: 'Label', name: 'Címke', typename: 'Label' }),
  LabelRelation: new CustomPropObjectTypeDetail({ id: 'LabelRelation', name: 'Címke kapcsolat', typename: 'LabelRelation' }),
  OfficialAct: new CustomPropObjectTypeDetail({ id: 'OfficialAct', name: 'Hivatalos cselekmény', typename: 'OfficialAct' }),
  SecGroup: new CustomPropObjectTypeDetail({ id: 'SecGroup', name: 'Jogosultsági csoport', typename: 'SecGroup' }),
  SecGroupRelation: new CustomPropObjectTypeDetail({ id: 'SecGroupRelation', name: 'Jogosultsági csoport kapcsolat', typename: 'SecGroupRelation' }),
  WorkflowTemplate: new CustomPropObjectTypeDetail({ id: 'WorkflowTemplate', name: 'Workflow sablon', typename: 'WorkflowTemplate' }),
};

export const CustomPropObjectTypeList: CustomPropObjectTypeDetail[] = [
  CustomPropObjectTypeMap.DataEntry,
  CustomPropObjectTypeMap.Organization,
  CustomPropObjectTypeMap.Assignment,
  CustomPropObjectTypeMap.Profile,
  CustomPropObjectTypeMap.ModificationRequest,
  CustomPropObjectTypeMap.ClarificationRequest,
  CustomPropObjectTypeMap.Batch,
  CustomPropObjectTypeMap.Case,
  CustomPropObjectTypeMap.Role,
  CustomPropObjectTypeMap.Form,
  CustomPropObjectTypeMap.Bulletin,
  CustomPropObjectTypeMap.CodeList,
  CustomPropObjectTypeMap.CodeListItem,
  CustomPropObjectTypeMap.Label,
  CustomPropObjectTypeMap.LabelRelation,
  CustomPropObjectTypeMap.OfficialAct,
  CustomPropObjectTypeMap.SecGroup,
  CustomPropObjectTypeMap.SecGroupRelation,
  CustomPropObjectTypeMap.WorkflowTemplate,
];

export enum CustomPropInputType {
  Singleline,
  Multiline,
  DatePicker,
  DropDown,
  Checkbox
}

export class CustomPropInputTypeDetail implements ModuleModel {
  public discriminator = 'CustomPropInputTypeDetail';
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const CustomPropInputTypeMap = {
  Singleline: new CustomPropInputTypeDetail({ id: 'Singleline', name: 'Egyszerű szöveg' }),
  Multiline: new CustomPropInputTypeDetail({ id: 'Multiline', name: 'Többsoros szöveg' }),
  DatePicker: new CustomPropInputTypeDetail({ id: 'DatePicker', name: 'Dátum' }),
  DropDown: new CustomPropInputTypeDetail({ id: 'DropDown', name: 'Lista' }),
  Checkbox: new CustomPropInputTypeDetail({ id: 'Checkbox', name: 'Jelölőnégyzet' }),
};

export const CustomPropInputTypeList: CustomPropInputTypeDetail[] = [
  CustomPropInputTypeMap.Singleline,
  CustomPropInputTypeMap.Multiline,
  CustomPropInputTypeMap.DatePicker,
  CustomPropInputTypeMap.DropDown,
  CustomPropInputTypeMap.Checkbox,
];

export class CustomPropTypeDescriptor implements ModuleModel {
  public discriminator = 'CustomPropTypeDescriptor';

  public id: string;
  public name: string;
  public description: string;
  public objectType: string;
  public inputType: CustomPropInputType;
  public argument: string;
  public usage: string;
  public reason: string;

  public href: string;
  public modified: Date;
  public deleted: Date;

  constructor(options?: {
    id: string;
    name: string;
    description: string;
    objectType: string;
    inputType: CustomPropInputType;
    argument: string;
    usage: string;
    reason: string;
  
    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
      this.description = options.description;
      this.objectType = options.objectType;
      this.inputType = options.inputType;
      this.argument = options.argument;
      this.usage = options.usage;
      this.reason = options.reason;
      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}

export class CustomPropValueWithReference {
  public id: string;
  public relatedObjectId: string;
  public reference: string;
  public value: string;
}


// WEBPACK FOOTER //
// ./src/app/modules/customprop.type/model/customprop.type.ts